// export const API_URI = process.env.NEXT_PUBLIC_API_URI || "";
// export const API_URI = "http://localhost:8000";
export const API_URI = process.env.REACT_APP_API_URI;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;